const experiences = [
  {
    id: 7,
    title: 'Full-stack Developer',
    company: 'CSM Media Application (Startup Company) | Fulltime',
    description:
      'Became a full-stack developer at a startup company. We built a semi-dating app, which enables friends to help each other forge meaningful connections and create unforgettable moments together.',
    date: {
      start: 'Sep 2023',
      end: 'Present'
    },
    activities: [
      'I developed several key features: friend requests (sending, accepting, and deleting), caption writing, friend matching, and sending likes. I created multiple pages linked to these functionalities.',
      'On the backend, I successfully developed several APIs, including those for authentication, matching, liking, and retrieving user data.',
      'I built all the APIs required to retrieve user data, track likes, manage matches, and handle events, including checking captions.',
      'I created multiple pages, such as user insights and events, while also designing the overall layout.',
      'I developed a responsive website based on a design provided in Figma, which includes key sections such as Home, About, and Contact. The application is built using ReactJS and Material-UI, ensuring a modern and user-friendly interface.'
    ]
  },
  {
    id: 6,
    title: 'Full-stack Developer, Fulltime',
    company: 'Visionic | CV Visi Teknologi Indonesia',
    description: 'Be a part of the Visionic Indonesia team as a fullstack developer with developing a web-based application.',
    date: {
      start: 'Apr 2023',
      end: 'Jul 2023'
    },
    activities: [
      'I have successfully configured themes for 6 websites for Politeknik Negeri Semarang.',
      'Set up the project website for PT Domba Mas Indonesia, and created multiple pages based on Figma design, including home, solusi, store locator, katalog produk, login, register, and several dashboard pages.',
      'I have also made several migrations and models, such as user, city, karyawan, gaji, etc., and developed a password reset feature for the HRIS System PT CDS Asia Electronics.'
    ]
  },
  {
    id: 5,
    title: 'ICStar Hackathon 2022',
    company: 'By PT Orbit Nasional Edukasi',
    description: 'Became a team leader and brought the team to the final and presented in front of the judges and all hackathon participants.',
    date: {
      start: 'Sep 2022',
      end: 'Dec 2022'
    },
    activities: [
      'Learned about UIPath',
      'Learned about RPA',
      'Learned about Machine Learning',
      'Learned about Automation',
      'Doing a final project.',
      'Presenting in front of the judges and all hackathon participants.'
    ]
  },
  {
    id: 4,
    title: 'Full-stack Developer, Certified Internship',
    company: 'Beecons | PT Baracipta Esa Engineering',
    description: 'Creating a Stufast platform, which is a platform for learning media that provides courses and training.',
    date: {
      start: 'Aug 2022',
      end: 'Dec 2022'
    },
    activities: [
      'Developing the Stufast platform.',
      'Developing homepages, course pages, and training pages.',
      'Developing cart pages, checkout pages, and bundle pages.',
      'Developing Search feature.'
    ]
  },
  {
    id: 3,
    title: 'Frontend Engineering',
    company: 'Ruangguru X Kampus Merdeka | Studi Independen',
    description: 'Completed an independent frontend engineering study program at Ruangguru with an intermediate level.',
    date: {
      start: 'Feb 2022',
      end: 'Jul 2022'
    },
    activities: [
      'Learned about HTML, CSS, and JavaScript.',
      'Learned about ReactJS.',
      'Learned about Testing Library.',
      'Learned about Git and GitHub.',
      'Learned about Agile Software Development.',
      'Learned about Scrum Framework.',
      'Learned about Public Speaking.',
      'Doing a final project.'
    ]
  },
  {
    id: 2,
    title: 'Laboratory Assistant',
    company: 'Dian Nuswantoro University',
    description:
      'Dian Nuswantoro University is one of the private universities in Semarang. As a laboratory assistant, I am in charge of helping students in the laboratory and helping lecturers in the laboratory.',
    date: {
      start: 'Sep 2021',
      end: 'Dec 2021'
    },
    activities: ['Helping students in the laboratory.', 'Helping lecturers in the laboratory.', 'Helping the laboratory manager in the laboratory.']
  },
  {
    id: 1,
    title: 'Activity Division Manager (Pengurus Divisi Kegiatan)',
    company: 'Dian Nuswantoro Computer Club (DNCC)',
    description:
      'Dian Nuswantoro Computer Club is one of the organizations at Dian Nuswantoro University. As one of the activities division managers, I am in charge of designing and supervising all DNCC activities.',
    date: {
      start: 'Sep 2020',
      end: 'Sep 2022'
    },
    activities: [
      'As a member of the event management at the 2020 BTNG event. Job desk: coordinating the job desk for all committees, managing event time, and making rundowns, rules, and event concepts.',
      'As a publication at the DINACOM 2020 event. Job desk: distributing posters and looking for media partners.',
      'Be a companion at the 2021 AFG event. Job desk: organize and direct participants according to groups.'
    ]
  }
]

export default experiences
